import PropTypes from "prop-types";

import { alignItems, fileTypeConfigs, fileTypes, strCode } from "../../../../../../../../consts";
import { t } from "../../../../../../../../services";

import {
  FlexContainers,
  Heading5,
  SVG,
  WrapperContainer
} from "../../../../../../../../components";
import { ListWithIconSection } from "./ListWithIconSection";
import { SummaryText, VersionInfo } from "./styled";

export const ListWithIconsPreview = ({ version, releaseNotes, mediaData, thumbnailsData }) => {
  const getIcon = (id) => {
    const media = mediaData.find((el) => el.id === id);
    const mediaType = media?.imageFile?.type;

    const isVideo = fileTypeConfigs[fileTypes.video].extensions.includes(mediaType);

    if (isVideo) {
      const thumbnail = thumbnailsData.find((el) => el.id === id);

      return thumbnail?.imageFile;
    }

    return media?.imageFile;
  };

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnStart} width={"100%"} gap={24} p={24}>
      <WrapperContainer Container={FlexContainers.FlexColumnStart} width={"100%"}>
        <SVG.SoftwareUpdateIcon />
        <Heading5>{t(strCode.SOFTWARE_UPDATE_TITLE)}</Heading5>
        {version && <VersionInfo>{t(strCode.RELEASE_NOTES_VERSION_INFO, { version })}</VersionInfo>}
        {releaseNotes?.summary && (
          <WrapperContainer mt={8}>
            <SummaryText>{releaseNotes?.summary}</SummaryText>
          </WrapperContainer>
        )}
      </WrapperContainer>

      <WrapperContainer
        Container={FlexContainers.FlexColumnStart}
        alignItems={alignItems.start}
        width={"100%"}
        gap={24}>
        {releaseNotes?.features.map((item) => {
          return (
            <ListWithIconSection
              key={item?.id}
              title={item?.title}
              description={item?.description}
              linkText={item?.linkText}
              icon={getIcon(item?.id)}
            />
          );
        })}
      </WrapperContainer>
    </WrapperContainer>
  );
};

ListWithIconsPreview.propTypes = {
  version: PropTypes.string.isRequired,
  releaseNotes: PropTypes.shape({
    features: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        icon: PropTypes.oneOfType([PropTypes.object, PropTypes.node]).isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired
      })
    ).isRequired,
    summary: PropTypes.string
  }).isRequired,
  mediaData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      imageFile: PropTypes.object.isRequired,
      mediaExtension: PropTypes.string.isRequired
    })
  ),
  thumbnailsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      imageFile: PropTypes.object.isRequired,
      mediaExtension: PropTypes.string.isRequired
    })
  )
};
